import React, { useEffect, useState } from 'react';
import { getDailyQuestionResponses, syncSleepDataFromSmartwatch } from '../../../../services/dailyQuestionService';
import DailySurveyChart from '../../Share/DailySurveyChart/DailySurveyChart';


const DailySurveyResult = ({ user }) => {
    const [responses, setResponses] = useState([]);

    useEffect(() => {
        const loadData = async () => {
            try {
                // Automatically sync sleep data from HealthData before fetching
                try {
                    await syncSleepDataFromSmartwatch(user._id);
                } catch (syncError) {
                    // Silently fail - continue with data fetch even if sync fails
                }

                // Fetch daily responses after sync
                const response = await getDailyQuestionResponses(user._id);
                setResponses(response.data);
            } catch (error) {
                console.error("Error fetching daily survey responses:", error);
            }
        };

        loadData();
    }, [user._id]);

    return (
        <div className="daily-survey-page">
            <h2>Daily Survey Data for User: {user.firstname}</h2>

            <DailySurveyChart
                responses={responses}
                noData={!responses || responses.length === 0}
                isAdmin={true}
            />

        </div>
    );
};

export default DailySurveyResult;
